import * as React from 'react';
import { observer } from 'mobx-react';
import { DragDropContext, Droppable, Draggable, DroppableProvided, DroppableStateSnapshot } from 'react-beautiful-dnd';




const getListStyle = (isDraggingOver:boolean) => ({
  background: isDraggingOver ? 'white' : '#f2f2f2',
});

export interface SortableItem {
  order:number;
  id:string;
}

export const reorder = (list:any, startIndex:number, endIndex:number):any => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

interface SortableListProps { headerItem?:JSX.Element, footerItem?:JSX.Element, className?:string, onReorderRequest?:(startIndex:number, endIndex:number)=>void }

@observer
export default class SortableList extends React.Component<SortableListProps>  {
  onDragEnd = (result:any) => {
    if (!result.destination) {
      return;
    }
    if(this.props.onReorderRequest) {
      this.props.onReorderRequest(result.source.index, result.destination.index);
    }
  }
  render(){
    return (
      <div className={`sortableList${this.props.className?' '+this.props.className:''}`}>
        {this.props.headerItem}
        <DragDropContext onDragEnd={this.onDragEnd} >
          <Droppable droppableId="droppable">
          {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
            <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)} {...provided.droppableProps}>
              {this.props.children}
              {provided.placeholder}
            </div>
          )}
          </Droppable>
        </DragDropContext>
        {this.props.footerItem}
      </div>
    );
  };
} 

const getItemStyle = (draggableStyle:any, isDragging:boolean) => ({
  userSelect: 'none',
  background: isDragging ? '#eee' : '#fff',
  // styles we need to apply on draggables
  ...draggableStyle,
});
// style={getItemStyle(provided.draggableProps, snapshot.isDragging)}

interface SortableListItemProps { 
  id:string; 
  disabled:boolean;
  index:number;
}

@observer
export class SortableListItem extends React.Component<SortableListItemProps> {
  render() {
    return (
      <Draggable key={this.props.id} draggableId={this.props.id} isDragDisabled={this.props.disabled} index={this.props.index}>
        {(provided, snapshot) => (
          <div ref={provided.innerRef} {...provided.draggableProps}  {...provided.dragHandleProps}>
            {this.props.children}
          </div>
        )}
      </Draggable>
    );
  }

}



